<template>
  <el-dialog
    title="筛选设置"
    :close-on-click-modal="false"
    :visible.sync="visible"
    :before-close="closeDialog"
    width="700px"
  >
    <el-alert title="拖动筛选条件可调整筛选样式，可左右拖动。" type="info" show-icon :closable="false" />
    <div class="flex-row margin-t">
      <div class="flex-column flex-1 border radius padding-lr">
        <div class="h-40 border-b flex-row-center-v">展示的筛选条件</div>
        <el-scrollbar class="scroll-hide-x" style="height: 400px">
          <div class="config-left-container" style="min-height: 400px">
            <div
              v-for="item in leftList"
              :key="item.uId"
              class="flex-row-center-v h-40 radius config-item-container margin-t padding-lr text-line cursor-move"
            >
              {{ item.name }}
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="flex-column flex-1 margin-l border radius padding-lr">
        <div class="h-40 border-b flex-row-center-v">折叠的筛选条件</div>
        <el-scrollbar class="scroll-hide-x " style="height: 400px">
          <div class="config-right-container" style="min-height: 400px">
            <div
              v-for="item in rightList"
              :key="item.uId"
              class="flex-row-center-v h-40 radius config-item-container margin-t padding-lr text-line cursor-move"
            >
              {{ item.name }}
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button size="small" @click="handleReset">重置</el-button>
      <el-button :loading="loading" size="small" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { useFormUtil } from '@/utils/form'
import { useSortUtil } from '@/utils/sort'
import { cloneDeep } from 'lodash'

export default {
  name: 'KqFormConfig',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    configParams: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sortableLeft: null,
      sortableRight: null,
      leftList: [],
      rightList: [],
      loading: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData()
        this.$nextTick(() => this.initSortable())
      }
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      const list = cloneDeep(this.configParams)
      this.leftList = list.filter(item => item.hide === 0)
      this.rightList = list.filter(item => item.hide === 1)
    },

    /**
     * 初始化拖拽排序
     */
    initSortable() {
      this.sortableLeft = useSortUtil.initTableSort({
        tableSelector: '.config-left-container',
        draggable: '.config-item-container',
        handle: '.config-item-container',
        callback: this.handleSortChangeLeft,
        group: 'formConfig'
      })
      this.sortableRight = useSortUtil.initTableSort({
        tableSelector: '.config-right-container',
        draggable: '.config-item-container',
        handle: '.config-item-container',
        callback: this.handleSortChangeRight,
        group: 'formConfig'
      })
    },

    /**
     * 左侧列表排序变化
     */
    handleSortChangeLeft(e) {
      const { from, to, oldIndex, newIndex } = e
      if (from.className.includes('config-left-container') && to.className.includes('config-right-container')) {
        const movedItem = this.leftList.splice(oldIndex, 1)[0]
        movedItem.hide = 1
        this.rightList.splice(newIndex, 0, movedItem)
      } else {
        this.leftList = useSortUtil.sort(this.leftList, e)
      }
    },

    /**
     * 右侧列表排序变化
     */
    handleSortChangeRight(e) {
      const { from, to, oldIndex, newIndex } = e
      if (from.className.includes('config-right-container') && to.className.includes('config-left-container')) {
        const movedItem = this.rightList.splice(oldIndex, 1)[0]
        movedItem.hide = 0
        this.leftList.splice(newIndex, 0, movedItem)
      } else {
        this.rightList = useSortUtil.sort(this.rightList, e)
      }
    },

    /**
     * 重置
     */
    async handleReset() {
      try {
        await this.$confirm('确定要重置筛选条件吗？', '操作确认', { type: 'warning' })
        this.leftList = []
        this.rightList = []
        this.$nextTick(() => {
          const list = useFormUtil.getFormConfig(this.type)
          this.leftList = list.filter(item => item.hide === 0)
          this.rightList = list.filter(item => item.hide === 1)
        })
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * 提交
     */
    async submit() {
      try {
        this.loading = true
        const list = [...this.leftList, ...this.rightList]
        await useFormUtil.saveFormConfig(this.type, list)
        this.$message.success('保存成功')
        this.$emit('callback', this.type, list)
        this.closeDialog()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.config-item-container {
  background-color: #f5f7f9;
}
</style>
